var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-8" }, [
    _c("div", { staticClass: "input-wrapper" }, [
      _vm._m(0),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.redirect_url,
            expression: "redirect_url",
          },
        ],
        ref: "redirect_url",
        staticClass: "form-control",
        attrs: { type: "text", disabled: _vm.disabled },
        domProps: { value: _vm.redirect_url },
        on: {
          change: _vm.update,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.redirect_url = $event.target.value
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "form-control-label" }, [
      _c("h4", [_vm._v("Redirect URL")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }